import classNames from 'classnames';
import { Img, Portal, svgSprite } from '../../../../../../hybrid/wrappers';
import css from './SponsorModal.module.scss';
import { useMemo, useState } from 'react';
import Image from 'next/image';
import T from '../../../../../../common/components/T';

export default function SponsorModal(props) {
    const { closeHandler, profileData } = props;
    const sponsor = profileData.sponsor || {};
    const contacts = useMemo(() => Object.entries(sponsor?.contacts || {}).filter((contact) => contact[1]), [sponsor]);
    const firstContacts = contacts?.slice(0, 2);
    const lastContacts = contacts?.slice(2);
    const [showLastContacts, setShowLastContacts] = useState(false);

    const getIcon = (type) => {
        switch (type) {
            case 'phone':
                return 'phone';
            case 'email':
            case 'whatsapp':
            case 'instagram':
            case 'facebook':
            case 'telegram':
            case 'twitter':
            case 'viber':
            case 'tiktok':
                return `${type}-colored`;
            case 'ok':
                return 'odnoklassniki-colored';
            case 'vk':
                return 'vkontakte-colored';
        }
    };

    const contactHander = (type, value) => {
        let href = '';

        switch (type) {
            case 'phone': {
                href = `tel:${value}`;
                break;
            }
            case 'email': {
                href = `mailto:${value}`;
                break;
            }
            case 'whatsapp': {
                href = `https://wa.me/${value}`;
                break;
            }
            case 'instagram': {
                href = `https://instagram.com/${value}`;
                break;
            }
            case 'facebook': {
                href = `https://facebook.com/${value}`;
                break;
            }
            case 'telegram': {
                href = `https://t.me/${value}`;
                break;
            }
            case 'twitter': {
                href = `https://twitter.com/${value}`;
                break;
            }
            case 'viber': {
                href = `viber://pa?chatURI=${value}`;
                break;
            }
            case 'tiktok': {
                href = `www.tiktok.com/${value}`;
                break;
            }
            case 'ok': {
                href = `https://ok.ru/${value}`;
                break;
            }
            case 'vk': {
                href = `https://vk.com/${value}`;
                break;
            }
            default:
                break;
        }

        const link = document.createElement('a');
        link.setAttribute('href', href);
        link.setAttribute('target', '_blank');
        link.click();
        link.remove();
    };

    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modal}>
                <button onClick={closeHandler} className={classNames('circleButton', css.close)}>
                    {svgSprite('cross', { className: css.closeSvg })}
                </button>
                <div className={css.block}>
                    <div className={css.blockHead}>
                        <div className={css.blockHeadAvatar}>
                            <div className={css.marketingInfo}>
                                <div className={css.packageIcon}>
                                    <Img
                                        className={classNames(css.package, `rank${sponsor?.marketing_profile?.rank?.id || 0}`)}
                                        src={`/src/img/ranks/rank${sponsor?.marketing_profile?.rank?.id || 0}.png`}
                                        alt={`Rank ${sponsor?.marketing_profile?.rank?.id || 0}`}
                                    />
                                </div>
                                <div className={css.packageIcon}>
                                    <Img
                                        className={classNames(
                                            css.package,
                                            `packageIcon${sponsor?.marketing_profile?.package?.id || 0}`
                                        )}
                                        src={`/src/img/packages/package${sponsor?.marketing_profile?.package?.id || 0}.png`}
                                        alt={`Package ${sponsor?.marketing_profile?.package?.id || 0}`}
                                    />
                                </div>
                            </div>
                            {sponsor?.image?.links?.preview ? (
                                <Image
                                    quality={100}
                                    className={css.avatarImage}
                                    src={sponsor?.image?.links?.preview}
                                    fill
                                    alt={'Sponsor avatar'}
                                />
                            ) : (
                                <div className={css.avatarNo}>{svgSprite('plug-user-image', { className: css.avatarNoSvg })}</div>
                            )}
                        </div>
                        <div className={css.blockHeadInfo}>
                            <p className={css.blockHeadLabel}>
                                <T textName='your_sponsor' defaultStr='Ваш спонсор' page='/office' />
                            </p>
                            <p className={css.blockHeadSponsorName}>{sponsor.full_name}</p>
                        </div>
                    </div>
                    <div className={css.blockBody}>
                        <div className={css.blockBodyItem}>
                            <p>
                                <T textName='user_sponsor_login' defaultStr='Логин' page='/office' />
                            </p>
                            <p className={css.blockBodyItemValue}>{sponsor.username}</p>
                        </div>
                        <div className={css.blockLine}></div>
                        <div className={css.blockBodyItem}>
                            <p>
                                <T textName='user_sponsor_package' defaultStr='Пакет' page='/office' />
                            </p>
                            <p className={css.blockBodyItemValue}>{sponsor.marketing_profile?.package?.name || '-'}</p>
                        </div>
                        <div className={css.blockLine}></div>
                        <div className={css.blockBodyItem}>
                            <p>
                                <T textName='user_sponsor_qualification' defaultStr='Квалификация' page='/office' />
                            </p>
                            <p className={css.blockBodyItemValue}>{sponsor.marketing_profile?.rank?.name || '-'}</p>
                        </div>
                        <div className={css.blockLine}></div>
                    </div>
                    <div className={classNames(css.blockFooter)}>
                        {firstContacts?.map(([type, value]) => (
                            <div key={type} onClick={() => contactHander(type, value)} className={css.sponsorContact}>
                                {svgSprite(getIcon(type), { className: css.sponsorContactSvg })}
                            </div>
                        ))}
                        {lastContacts?.length ? (
                            <div onClick={() => setShowLastContacts((s) => !s)} className={css.sponsorContact}>
                                {svgSprite('dots-horisontal', { className: css.sponsorContactSvg })}
                                {showLastContacts ? (
                                    <div className={css.contactsDropdown}>
                                        <div className={css.contactsDropdownContent}>
                                            {lastContacts?.map(([type, value]) => (
                                                <div
                                                    key={type}
                                                    className={css.contactsDropdownItem}
                                                    onClick={() => contactHander(type, value)}
                                                >
                                                    <div className={css.contactsDropdownItemIcon}>
                                                        {svgSprite(getIcon(type), { className: css.contactsDropdownItemSvg })}
                                                    </div>
                                                    <p className={css.contactsDropdownItemText}>{value}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </Portal>
    );
}
